import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { handleNewMessageDialogThunk } from '@common/reducers/CalendarThunks';
import { Fab, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';
import { namespace } from '@common/config/constants';
import { useIsMobile } from '@common/hooks/use-is-mobile';



const NewMessageFab: React.FC = () => {
    const { t, i18n } = useTranslation(namespace);

  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const whatsappDirection = useAppSelector((state) => state.UserReducer.userWhatsappDirection);
  const isRTL = i18n.dir(i18n.resolvedLanguage || i18n.language) === 'rtl';

  // The full-screen mobile editor sheet is opened BY this FAB — while it is open the
  // FAB (zIndex 99999, above the dialog) would float over the sticky footer and cover
  // Schedule Send. Hide it on mobile whenever the scheduled-message dialog is open.
  const isScheduleDialogOpen = useAppSelector((state) => state.AddScheduledMessageButtonReducer.open);
  if (isMobile && isScheduleDialogOpen) {
    return null;
  }

  const openAddScheduledMessageDialog = () => {
    // BE#657 (a) — the FAB carries no time context, so open a TRULY FRESH compose (no now-seed):
    // summary says "pick a date/time", Send gated. Explicit calendar slot/day clicks still seed
    // their chosen time elsewhere.
    dispatch(handleNewMessageDialogThunk({ fresh: true }));
  };

  return (
    <Tooltip title="New message" placement="left">
      <Fab
        onClick={openAddScheduledMessageDialog}
        sx={{
          position: 'fixed',
          bottom: '2rem',
          ...(isRTL ? { left: '2rem' } : { right: '2rem' }),
          background: 'var(--fab-bg)',
          color: 'var(--fab-text)',
          '&:hover': {
            background: 'var(--fab-hover-bg)',
          },
          zIndex: 99999,
        }}
        data-testid="new-message-fab"
      >
        <FaPlus style={{ height: '1rem', width: '1rem', color: 'var(--fab-text)' }} />
      </Fab>
    </Tooltip>
  );
};

export default NewMessageFab;
